import { Typography } from '@eventbrite/marmalade';

import styles from './Slots.module.scss';
import { Hosts } from './Hosts/Hosts';
import { TimeRange } from './TimeRange/TimeRange';
import { Slot } from './Slot';

interface Props {
  id: string;
  slots?: Slot[];
}

export const Slots: React.FC<Props> = ({ id, slots }) => {
  if (!slots || slots.length === 0) {
    return null;
  }

  return (
    <div className={styles.slots}>
      {slots.map((slot, index) => (
        <div key={`${id}-${slot.title}-${index}`} className={styles.slotItem}>
          <TimeRange startTime={slot.startTime} endTime={slot.endTime} />
          <Typography as="h3" variant="heading-xs" className={styles.title}>
            {slot.title}
          </Typography>
          <div className={styles.hosts}>
            <Hosts hosts={slot.hosts} />
          </div>
          <Typography as="p" className={styles.text}>
            {slot.description}
          </Typography>
        </div>
      ))}
    </div>
  );
};
